import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '@/lib/store';
import { useT } from '@/lib/i18n';
import { Logo } from '@/components/Logo';
import { ThemeSwitcher } from '@/components/ThemeSwitcher';
import { LanguageToggle } from '@/components/LanguageToggle';
import { InstallButton } from '@/components/InstallPrompt';
import { ShieldCheck, Share2, LifeBuoy, ArrowRight } from 'lucide-react';

export default function Onboarding() {
  const navigate = useNavigate();
  const t = useT();
  const complete = useApp((s) => s.completeOnboarding);
  const [i, setI] = useState(0);

  const screens = [
    { Icon: ShieldCheck, title: t('o1t'), body: t('o1b') },
    { Icon: Share2, title: t('o2t'), body: t('o2b') },
    { Icon: LifeBuoy, title: t('o3t'), body: t('o3b') },
  ];
  const last = i === screens.length - 1;
  const S = screens[i];
  const finish = () => { complete(); navigate('/app/start'); };

  return (
    <div className="min-h-screen flex flex-col" style={{ background: 'var(--background)' }}>
      <div className="mx-auto max-w-md w-full px-5 pt-6 flex items-center justify-between">
        <Logo />
        <div className="flex items-center gap-2">
          <LanguageToggle />
          <button data-testid="onboarding-skip-button" onClick={finish} className="text-sm font-semibold" style={{ color: 'var(--text-muted)' }}>{t('skip')}</button>
        </div>
      </div>

      <div className="flex-1 mx-auto max-w-md w-full px-5 flex flex-col items-center justify-center text-center ss-fade-in">
        <span className="inline-flex items-center justify-center w-20 h-20 rounded-3xl mb-6" style={{ background: 'var(--surface-alt)', color: 'var(--primary)' }}><S.Icon size={40} /></span>
        <h1 className="text-3xl font-extrabold" style={{ color: 'var(--text)' }}>{S.title}</h1>
        <p className="mt-3 text-base" style={{ color: 'var(--text-muted)' }}>{S.body}</p>
        {last && (
          <div className="mt-6 w-full space-y-4">
            <div><p className="text-xs mb-2" style={{ color: 'var(--text-muted)' }}>{t('o_pick')}</p><ThemeSwitcher compact /></div>
            <InstallButton className="w-full" label={t('l_install')} />
          </div>
        )}
      </div>

      <div className="mx-auto max-w-md w-full px-5 pb-8">
        <div className="flex justify-center gap-2 mb-4">
          {screens.map((s, idx) => (
            <span key={s.title} className="h-2 rounded-full transition-all" style={{ width: idx === i ? 24 : 8, background: idx === i ? 'var(--primary)' : 'var(--border)' }} />
          ))}
        </div>
        <button data-testid="onboarding-next-button" onClick={() => (last ? finish() : setI(i + 1))} className="w-full inline-flex items-center justify-center gap-2 rounded-full font-bold min-h-[52px] text-base transition-colors" style={{ background: 'var(--primary)', color: 'var(--primary-foreground)' }}>
          {last ? t('o_start') : t('next')} <ArrowRight size={20} />
        </button>
      </div>
    </div>
  );
}
